/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCommentDto
 */
export interface CreateCommentDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCommentDto
     */
    message: string;
}

/**
 * Check if a given object implements the CreateCommentDto interface.
 */
export function instanceOfCreateCommentDto(value: object): value is CreateCommentDto {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function CreateCommentDtoFromJSON(json: any): CreateCommentDto {
    return CreateCommentDtoFromJSONTyped(json, false);
}

export function CreateCommentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCommentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function CreateCommentDtoToJSON(json: any): CreateCommentDto {
    return CreateCommentDtoToJSONTyped(json, false);
}

export function CreateCommentDtoToJSONTyped(value?: CreateCommentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

